<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text">
        Atestados
      </v-col>
    </v-row>

    <v-row
      dense
      v-for="(medicalCertificate, index) in medicalCertificatesPatient"
      :key="medicalCertificate.id"
    >
      <v-col>
        <MedicalCertificateListItem
          :medicalCertificate="medicalCertificate"
          :index="index"
          :allowEdit="false"
          :allowDelete="false"
          :forcePrint="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import MedicalCertificateListItem from "@/components/medical_certificates/list/item.vue";

  export default {
    name: "MedicalCertificates",
    props: {
      patient: Object,
    },
    components: {
      MedicalCertificateListItem,
    },
    apollo: {
      medicalCertificatesPatient: {
        query: require("@/graphql/medical_certificate/medical_certificates_patient.gql"),
        variables() {
          return {
            patientId: this.patient.id,
          };
        },
        pollInterval: 20000,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
